import { Button, Flex, Image, Tag } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React, { useState } from 'react';
import { bgV2DataAPI } from '../api/bd-controller';
import { openNotification } from '../meta/globalToaster';

import './bg-page.css';

const BrandDiscoveryV2Page = () => {
  const [loading, setLoading] = useState(false);

  const [response, setResponse] = useState<any>(null);
  const [companyUrl, setCompanyUrl] = useState('');

  const checkBDResult = () => {
    if (companyUrl != '') {
      setResponse(null);
      setLoading(true);
      bgV2DataAPI({ companyUrl: companyUrl }).then((data) => {
        try {
          if (data?.status) {
            if (data?.status === 200 && data?.response) {
              successSubmission(data?.response);
            } else {
              failSubmission('Please try again later!');
            }
          } else {
            failSubmission('Please try again later!');
          }
        } catch (error) {
          failSubmission('Please try again later!');
        }
      });
    } else {
      failSubmission('All input fields Required.');
    }
  };

  const successSubmission = (data: any) => {
    setLoading(false);

    setResponse(data);
  };

  const failSubmission = (message: any) => {
    setLoading(false);
    openNotification({ message });
  };

  return (
    <div>
      <div className="container p-3">
        <div className="row">
          <div className="col-sm-12">
            <h4>Brand Discovery</h4>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-9">
            {/* <p className="a-input-label">Company URL</p> */}
            <TextArea
              value={companyUrl}
              onChange={(e) => {
                setCompanyUrl(e?.target?.value);
              }}
              placeholder="Company URL"
              rows={1}
            />
          </div>
          <div className="col-sm-3">
            <Button
              type="primary"
              size="large"
              style={{ width: '100%' }}
              onClick={() => {
                checkBDResult();
              }}
              loading={loading}
            >
              Check Result
            </Button>
          </div>
        </div>

        {response && (
          <>
            <div className="row">
              <div className="col-sm-12">
                <hr />
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <h5>{response?.name}</h5>
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-sm-6">
                <div className="row">
                  {response?.links?.map((item: any) => {
                    return (
                      <div className="col-sm-3">
                        <a href={item?.url} target="_blank">
                          {item?.name}
                        </a>
                      </div>
                    );
                  })}
                </div>

                <div className="row">
                  <div className="col-sm-12">
                    <p className="p-sub-txt">{response?.description}</p>
                    <p>{response?.longDescription}</p>
                  </div>

                  <div className="col-sm-12 mt-2">
                    <p>
                      <b>Theme colors</b>
                    </p>
                    <Flex gap="4px 0" wrap>
                      {response?.colors?.map((item: any) => {
                        return <Tag color={item?.hex}>{item?.hex}</Tag>;
                      })}
                    </Flex>
                  </div>

                  <div className="col-sm-12 mt-2">
                    <p>
                      <b>Fonts</b>
                    </p>
                    <Flex gap="4px 0" wrap>
                      {response?.fonts?.map((item: any) => {
                        return <Tag color={item?.hex}>{item?.name}</Tag>;
                      })}
                    </Flex>
                  </div>

                  <div className="col-sm-12 mt-3">
                    <p>
                      <b># of Employees:</b> {response?.company?.employees}
                    </p>
                    <p>
                      <b>Founded Year:</b> {response?.company?.foundedYear}
                    </p>
                    <p>
                      <b>Location:</b>{' '}
                      {`${response?.company?.location?.city} ${response?.company?.location?.state}, ${response?.company?.location?.subregion}, ${response?.company?.location?.region}, ${response?.company?.location?.country}`}
                    </p>
                  </div>

                  <div className="col-sm-12 mt-3">
                    <p>
                      <b>Industries</b>
                    </p>
                    <Flex gap="4px 0" wrap>
                      {response?.company?.industries?.map((item: any) => {
                        return <Tag color={item?.hex}>{`${item?.emoji} ${item?.name}`}</Tag>;
                      })}
                    </Flex>
                  </div>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="row">
                  <div className="col-sm-12">
                    <p>
                      <b>Logos</b>
                    </p>
                  </div>
                  {response?.logos?.map((item: any) => {
                    return item?.formats?.map((iItem: any) => {
                      return (
                        <div className="col-sm-4 p-5">
                          <Image height={100} width={'100%'} src={iItem?.src} />
                          <p className="text-center">{item?.theme}</p>
                        </div>
                      );
                    });
                  })}
                </div>

                <div className="row mt-4">
                  <div className="col-sm-12">
                    <p>
                      <b>Images</b>
                    </p>
                  </div>
                  {response?.images?.map((item: any) => {
                    return item?.formats?.map((iItem: any) => {
                      return (
                        <div className="col-sm-4 p-5">
                          <Image height={100} width={'100%'} src={iItem?.src} />
                        </div>
                      );
                    });
                  })}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BrandDiscoveryV2Page;
